import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { OfferComponent } from './offer/offer.component';
import { GroupSaleComponent } from './group-sale/group-sale.component';
import { SelectExistingOfferDialogComponent } from "./offer/select-existing-offer-dialog/select-existing-offer-dialog.component";

@Injectable({
	providedIn: 'root'
})
export class OrderItemsDialogsService {

	constructor(
		private appService: AppService,
		public dialog: MatDialog,

	) {
	}

	async selectBasketOffer(existingOffers, offer) {
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(SelectExistingOfferDialogComponent, {
				width: "300px",
				panelClass: 'rounded-dialog',
				disableClose: true,
				direction: this.appService.direction,
				data: {existingOffers, offer},
				maxWidth: '90vw',
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	async openOfferDialog(_offer, isEdit = false, basket?) {
		let wasEdit = false;
		if (basket) {
			const existingOffers = basket.filter(o => o.offer == _offer.offer);
			if (existingOffers.length) {
				const editOffer = await this.selectBasketOffer(existingOffers, _offer);
				if (editOffer) {
					return;
				}
			}
		}

		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(OfferComponent, {
				panelClass: ['to-offer-dialog', 'animated', 'fast', 'slideInLeft'],
				backdropClass: 'kiosk-fullscreen-backdrop',
                direction: this.appService.direction,
				//disableClose: true,
				closeOnNavigation: true,
				data: {
					offer: _offer,
					isEdit: isEdit,
					minWidth: 280
				},
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					resolve(result);
				}
			});
		});
	}

	openOfferBundleDialog($storage, group, mode?) {
		const needCheckCounters = mode == "summary" || mode == "up-sale";
		const maxOffersCount = needCheckCounters ? group.maxOffersInBundle || $storage.folderOptions.maxOffersInBundle || 12 : 12;

		let offers = [];
		group.allOffers.forEach(offer => {
			if (offers.length >= maxOffersCount) return;
			if (needCheckCounters && $storage.order.offerCounters[offer.offer]) return;
			offers.push(offer);
		});
		if (!offers.length) return Promise.resolve();
		group.offers = offers;

		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(GroupSaleComponent, {
				panelClass: 'rounded-dialog-nopad',
				backdropClass: 'dialog-backdrop-dark',
				disableClose: true,
				closeOnNavigation: false,
				width: "500px",
				maxWidth: '95vw',
				//maxWidth: 880,//group.maxDialogWidth || 800,
				//minWidth: 880,//group.maxDialogWidth || 800,
				data: {
					group: group,
					mode: mode,
					minWidth: 280
				},
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}


}
